import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { SegmentControl } from '@blade/ui-kit'
import { tradeSettingsModel } from '@root/features/trade/trade-settings'

import type { SegmentControlSize } from '@blade/ui-kit'
import type { TradeSettingsPreset } from '@root/entities/trade-settings/model'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  size?: SegmentControlSize
} & ClassNameProps

export const TradeSettingsPresetSelector: React.FC<Props> = ({
  className,
  size = 'h36',
}) => {
  const [presetsState] = useAtom(tradeSettingsModel.networkSettingsPresetsState)
  const [activePresetIndex] = useAtom(tradeSettingsModel.activePresetIndex)
  const setActivePreset = useAction(tradeSettingsModel.setActivePreset)

  if (!AsyncStateN.isSuccess(presetsState)) {
    return undefined
  }

  const presets = presetsState.value.presets

  const renderPreset = (preset: TradeSettingsPreset.Preset) => {
    const label = `P${preset.index + 1}`
    return (
      <SegmentControl.Item key={preset.index} value={preset.index}>
        <Emoji>{preset.emoji}</Emoji>
        <span>{label}</span>
      </SegmentControl.Item>
    )
  }

  return (
    <SegmentControl
      size={size}
      value={activePresetIndex}
      onChange={setActivePreset}
      className={className}
    >
      {presets.map(renderPreset)}
    </SegmentControl>
  )
}

const Emoji = styled.span`
  font-size: 12px;
  line-height: 1;
  margin-right: 4px;
`
